module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-funreport"
  }, [_c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.sharereport.pic.replace('../', './')
    }
  }), _vm._v(" "), _c('fun-head'), _vm._v(" "), _c('fun-report'), _vm._v(" "), _c('div', {
    staticClass: "funreport-actions"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.goIndex()
      }
    }
  }, [_vm._v("我的动物画像")]), _vm._v(" "), (_vm.fromChannel == 1) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.gotoWz()
      }
    }
  }, [_vm._v("更多精彩测试")]) : _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.gotoWz()
      }
    }
  }, [_vm._v("专业爱情测评")])]), _vm._v(" "), _c('yxl-logo')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-18db4a5a!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/sharereport.vue
// module id = 127
// module chunks = 2